import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", { class: "text-xl leading-8 block font-normal text-gray-500 mt-[1.3333333em]" }, [
  /*#__PURE__*/_createTextVNode("On November 8th 2011, the Estonian police, the FBI, and the NASA-OIG arrested seven men in "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.fbi.gov/news/stories/international-cyber-ring-that-infected-millions-of-computers-dismantled",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Operation Ghost Click"),
  /*#__PURE__*/_createTextVNode(". This group of people operated under the company name Rove Digital, and distributed viruses that changes the DNS settings of victims. The Estonian court found their guilt not proven, but one member later plead guilty in the USA, and was sentenced to seven and a quarter years in prison. This malware was known under the names of DNS changer, Alureon, TDSS, TidServ and TDL4.")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", { class: "mt-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full rounded-lg",
    src: "/img/learning/security/dns-changer/operation-ghost-click.jpg",
    alt: "What we imagine Operation Ghost Click must have looked like",
    title: "What we imagine Operation Ghost Click must have looked like",
    width: "1200",
    height: "600"
  }),
  /*#__PURE__*/_createElementVNode("figcaption", null, [
    /*#__PURE__*/_createTextVNode("What we imagine Operation Ghost Click must have looked like. By NsLookup.io. Licensed under "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://creativecommons.org/licenses/by/4.0/",
      title: "Creative Commons By 4.0 licence",
      rel: "nofollow"
    }, "CC By 4.0"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "What does the DNS Changer Malware do?", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("On March 12th 2012, the FBI announced that, under a court order, the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.isc.org/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "ISC"),
  /*#__PURE__*/_createTextVNode(" (Internet Systems Consortium) was operating a replacement DNS service for the Rove Digital network. This will allow affected networks time to identify infected hosts, and avoid sudden disruption of services to victim machines. These servers were to be shut off on July 9th 2012.")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "How Can I Protect Myself?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "If you were affected by this DNS Changer, then your DNS configuration has changed. You can make sure your operating system has the latest security patches, and update your configured DNS servers in its operating system. However, this malware is no longer being distributed, and many popular sites are now defended against this type of attack. So the chances of this still affecting you are very small.", -1)

import BlogPost from '@/components/layout/BlogPost.vue';

import { ruurtjan } from '@/common/authors';
import { learningBreadcrumb } from '@/model/Breadcrumb';
import { BlogMeta } from '@/common/blogMeta';

const meta: BlogMeta = {
  tag: 'Security',
  url: '/learning/security/dns-changer/',
  breadcrumbs: [learningBreadcrumb],
  title: 'What is the DNS Changer Malware?',
  description: 'The DNS changer malware changed the DNS servers of its victims. It was shut down by the FBI, Estonian police and NASA-OIG in 2011.',
  overviewImage: '/img/learning/security/dns-changer/operation-ghost-click-small.jpg',
  overviewImageAlt: 'Redirecting DNS traffic maliciously',
  overviewDescription: 'The DNS changer malware changed the DNS servers of its victims. It was shut down by the FBI, Estonian police and NASA-OIG in 2011.',
  author: ruurtjan,
  img1024x512: 'https://www.nslookup.io/img/learning/security/dns-changer/dns-changer-social.jpg',
  img1200x630: 'https://www.nslookup.io/img/learning/security/dns-changer/dns-changer-social.jpg',
  written: new Date('2022-04-19T23:49:01.320Z'),
  updated: new Date('2023-03-28T11:59:49.110Z'),
};

const __default__ = {
  meta,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DnsChanger',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": \"ImageObject\", \"author\": { \"@type\": \"Person\", \"email\": \"mailto:ruurtjan@nslookup.io\", \"image\": \"https://www.nslookup.io/img/ruurtjan-lg.jpg\", \"jobTitle\": \"CEO\", \"name\": \"Ruurtjan Pul\", \"url\": \"https://www.nslookup.io/about/ruurtjan-pul/\" }, \"copyrightHolder\": { \"@type\": \"Organization\", \"url\": \"https://www.nslookup.io/\", \"email\": \"hello@nslookup.io\" }, \"copyrightYear\": 2023, \"contentUrl\": \"https://www.nslookup.io/img/learning/security/dns-changer/operation-ghost-click.jpg\", \"license\": \"https://creativecommons.org/licenses/by/4.0/\", \"acquireLicensePage\": \"https://creativecommons.org/licenses/by/4.0/\" } ")
        ]),
        _: 1
      }))
    ])),
    _createVNode(BlogPost, {
      title: meta.title,
      description: meta.description,
      url: `https://www.nslookup.io${meta.url}`,
      breadcrumbs: meta.breadcrumbs,
      img1024x512: meta.img1024x512,
      img1200x630: meta.img1200x630,
      written: meta.written,
      updated: meta.updated,
      author: meta.author,
      editor: meta.editor
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("p", null, [
          _createTextVNode("The DNS changer malware pointed the victims DNS configuration to their own malicious DNS servers in Estonia, Chicago, and New York. This caused "),
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode("DNS lookup")
            ]),
            _: 1
          }),
          _createTextVNode(" queries to be directed to malicious DNS servers, and in turn allowed the group to re-route internet traffic to malicious web servers. These web servers then served to replace the links in search results, and replace ads on popular websites. At the time, DNS wasn't as secure as it is today, making this attack quite effective.")
        ]),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]),
      _: 1
    }, 8, ["title", "description", "url", "breadcrumbs", "img1024x512", "img1200x630", "written", "updated", "author", "editor"])
  ], 64))
}
}

})